var map = {
	"./favicon.ico": 3,
	"./favicon_114.png": 4,
	"./favicon_120.png": 5,
	"./favicon_144.png": 6,
	"./favicon_152.png": 7,
	"./favicon_167.png": 8,
	"./favicon_180.png": 9,
	"./favicon_57.png": 10,
	"./favicon_60.png": 11,
	"./favicon_72.png": 12,
	"./favicon_76.png": 13,
	"./favicon_fb.png": 14,
	"./windows_large.png": 15,
	"./windows_square.png": 16,
	"./windows_tiny.png": 17,
	"./windows_wide.png": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;